module.exports = __webpack_public_path__ + "img/water_tank.3948a7ba.svg";